import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";
import { Subject } from 'rxjs';
import { statusCode } from '../../../auth/models/commonEnum';
import { AuthenticationService, CommonService } from '../../../auth/service';
import { MyApplicationService } from '../my-application.service';
import * as converter from 'number-to-words';
import {
	ChartComponent,
	ApexAxisChartSeries,
	ApexChart,
	ApexPlotOptions,
	ApexXAxis,
	ApexFill,
	ApexDataLabels,
	ApexYAxis,
	ApexGrid
} from "ng-apexcharts";

export type ChartOptions = {
	series: ApexAxisChartSeries;
	chart: ApexChart;
	fill: ApexFill;
	dataLabels: ApexDataLabels;
	grid: ApexGrid;
	yaxis: ApexYAxis;
	xaxis: ApexXAxis;
	plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-view-coe-application',
  templateUrl: './view-coe-application.component.html',
  styleUrls: ['./view-coe-application.component.scss']
})

export class ViewCoeApplicationComponent implements OnInit {
	@ViewChild("chart") chart: ChartComponent;
	private _unsubscribeAll: Subject<any>;
	public chartOptions: Partial<ChartOptions>;
	public apexBarChart: Partial<ChartOptions>;
	public url = this.router.url;
	public ID: string;
	public form1_data;
	public stageData = [];
	public form1_data_Array = [];
	public form2_data = [];
	public form2_other_data;
	public form3coeArray = [];
	public form3manArray = [];
	public form3cocArray = [];
	public form3cocArrayHasRecord = false;
	public form4travelArray = [];
	public expertCommentRatingList = [];
	public applicationDetail: any;
	public format4: any;
	public expertList = [];
	public reviewList = [];
	public reportDetail = [];
	public contentHeader;
	isUser:boolean;
	total: any;
	firstYearTotal: any;
	secondYearTotal: any;
	thirdYearTotal: any;
	cocfirstYear_Total: any;
	cocsecondYear_Total: any;
	cocthirdYear_Total: any;
	costTotal: any;
	coctotalFecFirstYear: any;
	coctotalFecSecondYear: any;
	coctotalFecThirdYear: any;
	Fec_total: any;
	public progreeReportDetailsForm: FormGroup;
	public projectTitle: String;
	public principleInvestigator: String;
	public manpowerArray: [];
	public prEquipmentDetailsArray: any;
	public sanctionDetails: object;
	public documentUrl: any;
	public mandateDetails: any;
	public mandateFormURL: String;
	public reportDetails: any;
	public manPowerDetails: any;
	public STbenefitsDetails: any;
	public documentDowload: any;
	public projectExpenditure: any;
	public equipmentDetails: any;
	form1_data_TotalCost: any;
	releasedOrderNo: any;
	releasedDate: any;
	releasedAmount: any;
	public noOfyear: any;
	public noOfYeararray = [];
	public noOfYearisReset: boolean | false;
	dynamicColumnCount = 0;
	public documentList: [];
	projectExpenditureTotal: any;
	public userData: any;

	constructor(private router: Router, private _myApplicationService: MyApplicationService, private route: ActivatedRoute,
		private modalService: NgbModal, private _commonService: CommonService, private _formBuilder: FormBuilder,
		private _authenticationService: AuthenticationService) {
		this._unsubscribeAll = new Subject();
		//this.lastValue = this.url.substr(this.url.lastIndexOf('/') + 1);
		this.route.params.subscribe(parmas => {
			this.ID = parmas["id"];
		});
		this.contentHeader = {
			headerTitle: 'View COEs Application',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'COEs Application',
						isLink: true,
						link: '/coe-application'
					},
					{
						name: 'View COEs Application',
						isLink: false,
					},
				]
			}
		};
	}

	ngOnInit(): void {
		this.getCoeApplicationDetail(this.ID);
		this.isUser = this._authenticationService.isUser;
		this.format4 = this._formBuilder.group({
			EvalutionDocument: [],
			Remarks: [,],
			ApplicationID: [],
			expertEvalutionArray: this._formBuilder.array([

			])
		});
		this.progreeReportDetailsForm = this._formBuilder.group({
			projectTitle: [],
			NameOfPI: [],
			AddressOfPI: [],
			projectStartDate: [],
			projectEndDate: [],
			approvedBudget: [],
			sanctionNo: [],
			sanctionDate: [],
			sanctionAmount: [],
			actualExpenditure: [],
			approvedObjectivesProject: [],
			outputApprovedProject: [],
			summaryProgressReported: [],
			detailedProgress: [],
			newObservations: [],
			innovations: [],
			applicationPotential: [],
			projectAndWorkPlan: [],
			statusFinancialYearwise: [],
			applyonlineId: [],
			status: [],
			otherDocument: [],
			technicalReport: [],
			UCletter: [],
			SOEletter: [],
		});
		this.downloadCompletionReport(this.ID);
		this.getBankMandateDetail(this.ID);
		this.getCompletionReportDetails(this.ID);
	}

	setNoofYears(value: any){
		this.noOfyear = (value / 12);
		this.noOfYeararray = [];
		for(var i= 0; i< this.noOfyear; i++){
			let yearString =  converter.toWordsOrdinal((i + 1)) + " " + "Year";
			this.noOfYeararray.push({"key":yearString, "value":(i + 1), "label": yearString.replace(" ",""), "proposedCostTotal": 0, "costofConsumableTotal": 0});
		}
		this.dynamicColumnCount = (this.noOfYeararray.length + 1) + 4;
	}

	proposedCostArray: any;
	manpowerDetailArray: any;
	costOfConsumableArray: any;
	travelCostArray: any;
	getCoeApplicationDetail(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getCoeApplicationDetail(data).subscribe((result: any) => {
			this.applicationDetail = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.applicationDetail = result["data"]["response"];
				this.form1_data = this.applicationDetail.form1_data;
				this.setNoofYears(60);
				this.documentList 	=  this.applicationDetail.documentList;
				this.form1_data_Array = this.applicationDetail.form1Action_data;
				this.form1_data_TotalCost = this.applicationDetail.form1Action_totalCost;
				this.stageData = this.applicationDetail.stages;
				this.form2_data = this.applicationDetail.form2_data;
				this.setProposedCostData(this.form2_data);
				this.form2_other_data = this.applicationDetail.form2Other_data;
				this.form3coeArray = this.applicationDetail.form3coeArray;
				this.form3manArray = this.applicationDetail.form3manArray;
				this.setManpowerData(this.form3manArray);
				this.form3cocArray = this.applicationDetail.form3cocArray;
				this.setCostofConsumableData(this.form3cocArray);
				this.form3cocArrayHasRecord = (this.form3cocArray != undefined && this.form3cocArray.length > 0) ? true : false;
				this.cocfirstYear_Total = this.applicationDetail.form3cocArray.firstYear_Total;
				this.cocsecondYear_Total = this.applicationDetail.form3cocArray.secondYear_Total;
				this.cocthirdYear_Total = this.applicationDetail.form3cocArray.thirdYear_Total;
				this.costTotal = this.applicationDetail.form3cocArray.costTotal;

				this.coctotalFecFirstYear = this.applicationDetail.form3cocArray.totalFecFirstYear;
				this.coctotalFecSecondYear = this.applicationDetail.form3cocArray.totalFecSecondYear;
				this.coctotalFecThirdYear = this.applicationDetail.form3cocArray.totalFecThirdYear;
				this.Fec_total = this.applicationDetail.form3cocArray.Fec_total;
				this.form4travelArray = this.applicationDetail.forem4travelArray;
				this.setTravelCostArray(this.form4travelArray);
				this.expertList = this.applicationDetail.expert;
				this.setChartData(this.applicationDetail.application_timeline);
			}
		})
		this._myApplicationService.getreviewReportDetails(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.reviewList = result["data"]["response"];
			}
		})
	}

	numFormat(number){
        var outputformat = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2,minimumFractionDigits: 2 }).format(number);
        return outputformat;
    }

	
	setProposedCostData(data: any){
		this.proposedCostArray = [];
		if(data != "" && data.length > 0){
			data.forEach(element => {
				let model = new proposedCostModel();
				model.proposedCostItemName = element.proposedCostItemName;
				model.proposedCostItemID = element.proposedCostItemID;
				model.years = [];
				let totalCost = 0;
				this.noOfYeararray.forEach(element1 => {
					if(element[element1.label] != undefined){
						model.years.push({"key": element1.label, "value":  element[element1.label]});
						totalCost = totalCost + (element[element1.label].toString().includes(",") ? parseFloat(element[element1.label].toString().replaceAll(",","")) : 
						isNaN(parseFloat(element[element1.label].toString())) ? 0 : parseFloat(element[element1.label]));
					}
					else{
						model.years.push({"key": element1.label, "value": 0.00});
					}
				});
				model.totalCost = this.numFormat(totalCost);
				this.proposedCostArray.push(model);
			});
			this.setProposedcostTotal();
		}
	}

	setProposedcostTotal(){
		var allTotal = 0.00;
		if(this.noOfYeararray.length > 0){
			this.noOfYeararray.forEach(ele => {
				var formControlname = ele.label;
				var colTotal = 0;
				this.proposedCostArray.forEach(ele => {
					ele.years.forEach(element => {
						if(element.key == formControlname){
							let value = isNaN(parseFloat(element.value)) ? 0 :
							parseFloat(element.value.toString().includes(",") ? parseFloat(element.value.replaceAll(",","")) :  element.value);
							colTotal = colTotal + value;	
						}
					});
					
				});
				ele.proposedCostTotal = this.numFormat(colTotal.toFixed(2));
			});
		}

		this.proposedCostArray.forEach(element => {
			allTotal = allTotal + parseFloat(element.totalCost.toString().includes(",") ? element.totalCost.replaceAll(",","") : element.totalCost);
		});
		this.total = this.numFormat(allTotal.toFixed(2));
	}

	setManpowerData(data: any){
		this.manpowerDetailArray = [];
		if(data != "" && data.length > 0){
			data.forEach(element => {
				let model = new manpowerModel();
				model.designation = element.designation;
				model.justification = element.justification;
				model.monthlyEmoluments = element.monthlyEmoluments;
				model.years = [];
				let totalCost = 0;
				this.noOfYeararray.forEach(element1 => {
					if(element[element1.label] != undefined){
					model.years.push({"key": element1.label, "value":  element[element1.label]});
					totalCost = totalCost + (element[element1.label].toString().includes(",") ? parseFloat(element[element1.label].toString().replaceAll(",","")) : 
					isNaN(parseFloat(element[element1.label].toString())) ? 0 : parseFloat(element[element1.label]));
					}
					else{
						model.years.push({"key": element1.label, "value": 0.00});
					}
				});
				model.total =  this.numFormat(totalCost);
				this.manpowerDetailArray.push(model);
			});
		}
	}

	setCostofConsumableData(data: any){
		this.costOfConsumableArray = [];
		if(data != "" && data.length > 0){
			data.forEach(element => {
				let model = new costOfConsumableModel();
				model.item = element.item;
				model.qty = element.qty;
				model.unitName = element.unitName;
				model.years = [];
				this.noOfYeararray.forEach(element1 => {
					if(element[element1.label] != undefined){
					model.years.push({"key": element1.label, "value":  element[element1.label]});
					}
					else{
						model.years.push({"key": element1.label, "value": 0.00});
					}
				});
				this.costOfConsumableArray.push(model);
			});
			this.setCostOfConsumableTotal();
		}
	}

	setCostOfConsumableTotal(){
		if(this.noOfYeararray.length > 0){
			this.noOfYeararray.forEach(ele => {
				var formControlname = ele.label;
				var colTotal = 0;
				this.costOfConsumableArray.forEach(ele => {
					ele.years.forEach(element => {
						if(element.key == formControlname){
							let value = isNaN(parseFloat(element.value)) ? 0 :
							parseFloat(element.value.toString().includes(",") ? parseFloat(element.value.replaceAll(",","")) :  element.value);
							colTotal = colTotal + value;	
						}
					});
					
				});
				ele.costofConsumableTotal = this.numFormat(colTotal.toFixed(2));
			});
		}
	}

	setTravelCostArray(data:any){
		this.travelCostArray = [];
		if(data != "" && data.length > 0){
			data.forEach(element => {
				let model = new travelCostModel();
				model.title = element.title;
				model.justification = element.justification;
				model.years = [];
				let totalCost = 0;
				this.noOfYeararray.forEach(element1 => {
					if(element[element1.label] != undefined){
					model.years.push({"key": element1.label, "value": element[element1.label]});
					totalCost = totalCost + (element[element1.label].includes(",") ? parseFloat(element[element1.label].replaceAll(",","")) : 
					isNaN(parseFloat(element[element1.label])) ? 0 : parseFloat(element[element1.label]));
					}
					else{
						model.years.push({"key": element1.label, "value": 0.00});
					}
				});
				model.total =  this.numFormat(totalCost);
				this.travelCostArray.push(model);
			});
		}
	}

	downloadDocument(progressReportId) {
		//alert(progressReportId);
	}
	setChartData(applicationTimeline) {
		var projectPlanArrayList = applicationTimeline;
		let data = [];
		if (projectPlanArrayList.length > 0) {
			projectPlanArrayList.forEach(element => {
				if (element.start_date != null && element.end_date != null && element.name != null) {
					let startDate = element.start_date;
					let endDate = element.end_date;
					data.push({
						x: element.name,
						y: [new Date(startDate).getTime(),
						new Date(endDate).getTime()],
						fillColor: this.getRandomColor()
					})
				}
			});
		}
		this.chartOptions = {
			series: [{ data: data }],
			chart: {
				height: 350,
				type: "rangeBar",
				zoom: {
					enabled: false
				},
				toolbar: {
					show: false
				}
			},
			plotOptions: {
				bar: {
					horizontal: true,
					distributed: true,
					dataLabels: {
						hideOverflowingLabels: false
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter: function (val, opts) {
					var label = opts.w.globals.labels[opts.dataPointIndex];
					var a = moment(val[0]);
					var b = moment(val[1]);
					var diff = b.diff(a, "days");
					return label + ": " + diff + (diff > 1 ? " days" : " day");
				},
				style: {
					colors: ["#f3f4f5", "#fff"]
				}
			},
			xaxis: {
				type: "datetime"
			},
			yaxis: {
				show: false
			},
			grid: {
				row: {
					colors: ["#f3f4f5", "#fff"],
					opacity: 1
				}
			}
		};
	}
	getRandomColor() {
		var color = Math.floor(0x1000000 * Math.random()).toString(16);
		return '#' + ('000000' + color).slice(-6);
	}

	viewComment(modalExpertEvalution, id) {
		let expertID = id;
		this.getExpertComments(expertID);
		this.modalService.open(modalExpertEvalution, { size: 'xl', scrollable: true });
	}

	clearFormArray = (formArray: FormArray) => {
		while (formArray.length !== 0) {
			formArray.removeAt(0)
		}
	}


	//expertEvalutionForm: FormGroup;
	getExpertComments(expertID) {
		const data = {
			expertId: expertID,
			applyonlineId: this.ID
		}
		this._myApplicationService.getExpertCommentByID(data).subscribe((result: any) => {
			this.clearFormArray(<FormArray>this.format4.controls['expertEvalutionArray']);
			this.expertCommentRatingList = [];
			if (result.statusCode == statusCode.SUCCESS) {
				result["data"]["response"]["commentsDetails"].forEach(element => {
					this.expertCommentRatingList.push({
						parentPara: element.parentPara,
						parentid: element.parentid,
						comments: element.comments,
						evolutionRating: (element.rating == 100) ? result["data"]["response"].totalRating : element.evolutionRating,
						rating: element.rating,
						childPara: element.childPara
					});
					const expertEvalutionArray = <FormArray>this.format4.controls['expertEvalutionArray'];
					expertEvalutionArray.push(this.initExpertEvalutionRow(element.parentPara,
						element.parentid, element.rating, element.childPara, element.comments, (element.rating == 100) ? result["data"]["response"].totalRating : element.evolutionRating));
				});
				this.format4.controls.EvalutionDocument.setValue(result["data"]["response"]["expertEvalutionDocument"]);
				this.format4.controls.Remarks.setValue(result["data"]["response"]["remark"]);
			}
		})
	}

	initExpertEvalutionRow(name: string, id: number, rating: number, childPara: [], comments: string, givenRating: string): FormGroup {
		return this._formBuilder.group({
			parentPara: [name],
			parentid: [id],
			rating: [rating],
			childPara: [childPara],
			comments: [comments],
			givenRating: !isNaN(parseInt(givenRating)) ? givenRating : 0,
		});
	}
	/**
	 * function for open model popup for accept/reject review report.
	 ***/
	progressReportDetails(modalPR, progressReportId) {
		//this.progreeReportDetailsForm.reset();
		this.getprogressReportDetails(progressReportId);
		this.modalService.open(modalPR, { size: 'xl', scrollable: true });
	}

	get progreeReportForm() {
		return this.progreeReportDetailsForm.controls;
	}

	getprogressReportDetails(progressReportId) {
		const data = {
			progressReportId: progressReportId
		}
		this._myApplicationService.getprogressReportDetail(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				let progressReportDetail = result["data"]["response"].progressReportDetails;
				let manPowerDetail = result["data"]["response"].manPowerDetails;
				let sanctionDetail = result["data"]["response"].sanctionDetails;
				let prEquipmentDetails = result["data"]["response"].prEquipmentDetails;
				this.releasedOrderNo = progressReportDetail.releasedOrderNo;
				this.releasedDate = progressReportDetail.releasedDate;
				this.releasedAmount = progressReportDetail.releasedAmount;
				if (progressReportDetail != null && progressReportDetail.id > 0) {
					this.progreeReportDetailsForm.patchValue(progressReportDetail);
				}
				if (manPowerDetail.length > 0) {
					this.manpowerArray = manPowerDetail;
				}

				if (prEquipmentDetails.length > 0) {
					this.prEquipmentDetailsArray = prEquipmentDetails;
				}else{
					this.prEquipmentDetailsArray = 0;
				}
				this.sanctionDetails = sanctionDetail;
			}
		})
	}

	public downloadCompletionReport(applicationId) {
		const data = {
			applyonlineId: applicationId
		}
		this._myApplicationService.CompletionReport(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.documentUrl = result["data"]["response"];
			}
		})
	}
	getBankMandateDetail(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getBankMandateDetail(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.mandateDetails = result["data"]["response"].mandateDetails;
				// this.bankFormData.isBondUpload.setValue(result["data"]["response"].isBondUpload);
				// if (this.mandateDetails != null && this.mandateDetails.id > 0) {
				// 	this.bankdetailsform.patchValue(this.mandateDetails);
				// 	this.bankdetailsform.controls.isTinApplicable.setValue(this.mandateDetails.isTinApplicable.toString());
				// 	this.bankdetailsform.controls.typeOfBankAccount.setValue(parseInt(this.mandateDetails.typeOfBankAccount));
				// 	this.bankdetailsform.controls.id.setValue(this.mandateDetails.id);
				// 	this.onOptionsSelected(this.mandateDetails.isTinApplicable);
				// 	this.uploadCancelChequeUrl = this.mandateDetails.chequeDocumentUrl;
				// 	this.bondDocumentUrl = this.mandateDetails.bondDocumentUrl;
				// 	this.signedDocumentUrl = this.mandateDetails.signedMandateUrl;
				this.mandateFormURL = this.mandateDetails.mandateFormURL;
				// }
			}
		})
	}
	completionReportDetails(modalCR) {
		this.modalService.open(modalCR, { size: 'xl', scrollable: true });
	}
	getCompletionReportDetails(applicationId) {
		const data = {
			applyonlineId: applicationId
		}
		this._myApplicationService.completionReportDetails(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.reportDetails = result["data"]["response"];
				this.STbenefitsDetails = this.reportDetails.STbenefitsDetails;
				this.documentDowload = this.reportDetails.documentDetails;
				this.projectExpenditure = this.reportDetails.expenditureDetails.details;
				this.projectExpenditureTotal = this.reportDetails.expenditureDetails.total;
				this.equipmentDetails = this.reportDetails.equipmentDetails;
			}
		})
		this._myApplicationService.getManpowerForCompletionReport(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.manPowerDetails = result["data"]["response"];
			}
		})
	}
	mandateDetailsModel(modalBM) {
		this.modalService.open(modalBM, { size: 'lg', scrollable: true });
	}
	
}


export class proposedCostModel {
	proposedCostItemName: string;
	proposedCostItemID: number;
	totalCost: string;
	years: any;
}

export class manpowerModel{
	designation:string;
	justification: string;
	monthlyEmoluments: string;
	total: string;
	years: any;
}

export class costOfConsumableModel{
	item: string;
	qty: string;
	unitName: string;
	years: any;
}

export class travelCostModel{
	title:string;
	justification: string;
	total: string;
	years: any;
}
